import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
declare var tinymce: any;

@Component({
  selector: 'html-editor',
  template: `<textarea [ngStyle]="{'height.em': height}" id="{{elementId}}">{{initText}}</textarea>`
})
export class HtmlEditorComponent implements AfterViewInit, OnDestroy {
  @Input() elementId: String;
  @Input() initText: String;
  @Input() height: number;
  @Output() onEditorKeyup = new EventEmitter<any>();

  editor: any;

  ngAfterViewInit() {
    //console.log('A',this.model);
    tinymce.init({
      selector: '#' + this.elementId,
      //selector: "[editorId='"+this.editorId+"']",
      plugins: ['image','link', 'paste', 'table', 'code'],
      menubar: false,
      toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright | link image | table | code',
      skin_url: '/resources_admin/css/skins/light',
      content_css : ['/resources_front/assets/css/bootstrap.css',
                     '/resources_front/assets/css/et-line-icons.css',
                     '/resources_front/assets/css/font-awesome.min.css',
                     '/resources_front/assets/css/settings.css',
                     '/resources_shared/assets/fonts/montserrat-v10-latin.css',
                     '/resources_front/assets/css/style.css',
                     '/resources_front/assets/custom/front.css',
                     '/resources_front/assets/css/responsive.css',
                     '/resources_shared/assets/css/footnotes.css'],
      content_style: "img {max-width: 500px}",
      relative_urls: false,
      extended_valid_elements : "sup[text]",
      setup: (editor:any) => {
        // Data binding
        this.editor = editor;
        editor.on('MouseLeave', () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content); 
        });
      },
    });
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/html-editor.component.ts